import type { FallbackProps } from "react-error-boundary";
import { AppErrorBoundaryLayout } from "@/components/organisms/appErrorBoundaryLayout";
import { getAppLevelErrorFallbackSession } from "@/contexts/SessionAuthContext";

export const AppRootErrorFallbackAppLevel = ({
  error,
  resetErrorBoundary,
}: FallbackProps) => {
  const { givenName, postSessionLogout } = getAppLevelErrorFallbackSession();

  return (
    <AppErrorBoundaryLayout
      error={error}
      resetErrorBoundary={resetErrorBoundary}
      givenName={givenName}
      onLogout={() => {
        void postSessionLogout();
      }}
    />
  );
};
